// extracted by mini-css-extract-plugin
export default {"root":"Contribution_root__2aQWX","icon":"Contribution_icon__1NaDg","content":"Contribution_content__12X5F"};